import { useState, useEffect } from 'react';
import { createEnquiry } from '../../service/apiFetch';
import { FaPhoneAlt, FaMapMarkerAlt, FaEnvelope } from 'react-icons/fa';

export default function ContactWithMap({ data, websitedata }) {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    message: '',
    source: 'Website',
    firm: '680df280bcc685c765453004',
    session: '680df2e465f539617559a3bb',
    currentStatus: 'Pending',
    center: '680df2cabcc685c765453007',
    enquiryType: '680c7a6237d0e861fb94102f'
  });

  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [contactDetails, setContactDetails] = useState({});

  useEffect(() => {
    setContactDetails(websitedata.website || {});
  }, [websitedata]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === 'name') {
      const nameParts = value.split(' ');
      if (nameParts.length > 1) {
        const firstName = nameParts[0];
        const lastName = nameParts.slice(1).join(' ');
        setFormData(prevData => ({
          ...prevData,
          firstName,
          lastName
        }));
      } else {
        setFormData(prevData => ({
          ...prevData,
          firstName: value,
          lastName: ''
        }));
      }
    } else {
      setFormData(prevData => ({
        ...prevData,
        [name]: type === 'checkbox' ? checked : value
      }));
    }

    if (errors[name]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.firstName.trim()) {
      newErrors.name = "Name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is not valid";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      setLoader(true);
      setErrors({});

      const response = await createEnquiry(formData);

      if (response && !response.error) {
        setIsSuccess(true);
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          message: '',
          source: 'Website',
          firm: '680df280bcc685c765453004',
          session: '680df2e465f539617559a3bb',
          currentStatus: 'Pending',
          center: '680df2cabcc685c765453007',
          enquiryType: '680c7a6237d0e861fb94102f'
        });
      } else {
        const errorMessage = response?.error?.message || response?.message || "Failed to submit form. Please try again.";
        setErrors(prev => ({
          ...prev,
          apiError: errorMessage
        }));
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.message || "Failed to submit form. Please try again later.";
      setErrors(prev => ({
        ...prev,
        apiError: errorMessage
      }));
    } finally {
      setLoader(false);
    }
  };

  const PhoneIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
    </svg>
  );

  const ClockIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <polyline points="12 6 12 12 16 14"></polyline>
    </svg>
  );

  const MapPinIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
      <circle cx="12" cy="10" r="3"></circle>
    </svg>
  );

  const ArrowRightIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="5" y1="12" x2="19" y2="12"></line>
      <polyline points="12 5 19 12 12 19"></polyline>
    </svg>
  );

  return (
    <div className="w-full container mx-auto mb-5 px-4 sm:px-6 lg:px-8">
      {/* Responsive Map Container with improved height for different screen sizes */}
      <div className="relative w-full h-64 sm:h-80 md:h-96 lg:h-[400px] xl:h-[500px] bg-gray-200 mt-10 rounded-lg overflow-hidden shadow-md">
        {contactDetails.gmCode ? (
          <div
            className="w-full h-full"
            dangerouslySetInnerHTML={{
              __html: contactDetails.gmCode
                .replace(/width="\d+"/g, 'width="100%"')
                .replace(/height="\d+"/g, 'height="100%"')
                .replace('style="border:0;"', 'style="border:0; display:block; position:absolute; top:0; left:0; width:100%; height:100%;"')
            }}
          ></div>
        ) : (
          <div className="flex items-center justify-center h-full text-gray-500">
            Map loading...
          </div>
        )}
      </div>

      <div className="flex flex-col lg:flex-row mt-6 gap-8">
        <div className="w-full lg:w-1/2">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-6">Enquire Now</h2>

          {isSuccess ? (
            <div className="bg-green-100 border border-green-400 text-green-700 px-4 sm:px-6 py-4 rounded-lg mb-4">
              <p className="font-bold text-lg mb-2">Thank you for your message!</p>
              <p>Your message has been received successfully. We'll be in touch soon!</p>
              <button
                type="button"
                className="mt-4 flex items-center px-4 py-2 bg-green-600 text-white rounded-full hover:bg-green-700 transition-colors"
                onClick={() => setIsSuccess(false)}
              >
                <span className="mr-2">Send another message</span>
                <ArrowRightIcon />
              </button>
            </div>
          ) : (
            <div className="space-y-4">
              {errors.apiError && (
                <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg mb-4">
                  <p>{errors.apiError}</p>
                </div>
              )}

              <div className="relative">
                <input
                  type="text"
                  name="name"
                  aria-label="Name"
                  placeholder="Name"
                  value={formData.firstName + (formData.lastName ? ' ' + formData.lastName : '')}
                  onChange={handleChange}
                  className={`w-full p-3 border ${errors.name ? 'border-red-300 bg-red-50' : 'border-gray-300'} rounded focus:outline-none focus:ring-2 focus:ring-blue-300`}
                />
                {errors.name && (
                  <p className="absolute text-xs text-red-600 mt-1 ml-3">{errors.name}</p>
                )}
              </div>

              <div className="relative">
                <input
                  type="email"
                  name="email"
                  aria-label="Email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  className={`w-full p-3 border mt-2 ${errors.email ? 'border-red-300 bg-red-50' : 'border-gray-300'} rounded focus:outline-none focus:ring-2 focus:ring-blue-300`}
                />
                {errors.email && (
                  <p className="absolute text-xs text-red-600 mt-1 ml-3">{errors.email}</p>
                )}
              </div>

              <div className="relative">
                <textarea
                  name="message"
                  aria-label="Message"
                  placeholder="Message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  className={`w-full p-3 border mt-2 ${errors.message ? 'border-red-300 bg-red-50' : 'border-gray-300'} rounded focus:outline-none focus:ring-2 focus:ring-blue-300`}
                ></textarea>
                {errors.message && (
                  <p className="absolute text-xs text-red-600  ml-3">{errors.message}</p>
                )}
              </div>

              <div className="flex justify-end">
                <button
                  type="submit"
                  onClick={handleSubmit}
                  className="bg-[#334821] text-white px-6 py-3 rounded-full flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-all"
                  disabled={loader}
                >
                  {loader ? (
                    <span className="inline-block w-5 h-5 border-t-2 border-b-2 border-white rounded-full animate-spin mr-2"></span>
                  ) : null}
                  <span>{loader ? 'Sending...' : 'Send Now'}</span>
                  <span className="bg-white rounded-full p-1 ml-2">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#334821" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                      <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                  </span>
                </button>
              </div>
            </div>
          )}
        </div>

        <div className="w-full lg:w-1/2 mt-8 lg:mt-0">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-6">Our Contacts</h2>
          <div className="space-y-6">
            <div className="flex items-start">
              <div className="p-3 bg-orange-50 rounded-full mr-4 text-orange-400 flex-shrink-0">
                <PhoneIcon />
              </div>
              <div>
                <h3 className="font-semibold text-gray-800">Call</h3>
                <p className="text-gray-600 break-words">{contactDetails.contactNumber?.[0] || 'Contact number not available'}</p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="p-3 bg-orange-50 rounded-full mr-4 text-orange-400 flex-shrink-0">
                <FaEnvelope size={24} /> {/* Email Icon */}
              </div>
              <div>
                <h3 className="font-semibold text-gray-800">Email</h3>
                <p className="text-gray-600 break-words">{contactDetails.email || 'Email not available'}</p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="p-3 bg-orange-50 rounded-full mr-4 text-orange-400 flex-shrink-0">
                <MapPinIcon />
              </div>
              <div>
                <h3 className="font-semibold text-gray-800">Address</h3>
                <p className="text-gray-600">{contactDetails.address || 'Address not available'}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}